import { FoodsIcon } from "@foodpilot/foods";
import { Box, Paper, Stack, Switch, Typography, useTheme } from "@mui/material";
import { Fragment } from "react/jsx-runtime";
import { FeatureSubmodule } from "./FeatureSubmodule";
import { EntityItem } from "../feature.types";

type Props = {
    entity: EntityItem;
};
export const MainEntitySection = (props: Props) => {
    const theme = useTheme();

    const { entity } = props;

    return (
        <Box sx={{ marginBottom: "40px" }}>
            {/* Entity in Header with Features */}
            <Paper
                elevation={0}
                sx={{
                    border: "1px solid #E7E6E4",
                    borderRadius: "8px 8px 0px 0px",
                    backgroundColor: "white",
                    padding: "24px 16px",
                }}
            >
                <Stack direction="row" alignItems="center" gap={2} justifyContent={"space-between"}>
                    <Stack flexDirection={"row"} alignItems="center" gap={2}>
                        <Fragment>
                            <FoodsIcon icon={entity.icon as any} size={2} />
                            <Stack>
                                <Typography
                                    variant="body"
                                    sx={{
                                        color: "#393A36",
                                    }}
                                >
                                    {entity.name}
                                </Typography>
                                <Typography
                                    variant="small"
                                    sx={{
                                        color: "#767673",
                                    }}
                                >
                                    {entity.description}
                                </Typography>
                            </Stack>
                        </Fragment>
                    </Stack>
                    <Switch
                        checked={entity.enabled}
                        onChange={(e) => entity.onToggle?.(e.target.checked)}
                        sx={{
                            width: 44,
                            height: 24,
                            padding: 0,
                            "& .MuiSwitch-switchBase": {
                                padding: 0,
                                margin: "4px",
                                transitionDuration: "300ms",
                                "&.Mui-checked": {
                                    transform: "translateX(20px)",
                                    color: "#fff",
                                    "& + .MuiSwitch-track": {
                                        backgroundColor: theme.palette.primary[600],
                                        opacity: 1,
                                        border: 0,
                                    },
                                },
                            },
                            "& .MuiSwitch-thumb": {
                                boxSizing: "border-box",
                                width: 16,
                                height: 16,
                            },
                            "& .MuiSwitch-track": {
                                borderRadius: 20,
                                backgroundColor: "#D8D7D5",
                                opacity: 1,
                                transition: "background-color 0.5s",
                            },
                        }}
                    />
                </Stack>
            </Paper>

            {/* Features Section */}
            <Paper
                elevation={0}
                sx={{
                    border: "1px solid #E7E6E4",
                    borderTop: "none",
                    borderRadius: "0px 0px 8px 8px",
                    backgroundColor: "#FEFCFB",
                    padding: "24px",
                }}
            >
                {entity.enabled === false ?
                    <Stack spacing={2} flexDirection={"row"} alignItems="center" justifyContent={"center"} gap={2}>
                        <Typography variant="body-medium">{"Deactivated"}</Typography>
                    </Stack>
                :   <Stack spacing={2}>
                        {entity.features.map((feature, index) => (
                            <FeatureSubmodule key={feature.name} feature={feature} index={index} />
                        ))}
                    </Stack>
                }
            </Paper>
        </Box>
    );
};
